// extracted by mini-css-extract-plugin
export default {"booksCarouselContainer":"BooksCarousel_booksCarouselContainer__hLzye"};